import { useEffect, useRef, useState } from "react";
import type { Idioma, Origen } from "../lib/tipos";
import { t } from "../lib/i18n";

export function Composer({ idioma, ocupado, valor, alValor, alEnviar, alDetener, origenMundo }: {
  idioma: Idioma; ocupado: boolean; valor: string;
  alValor: (v: string) => void; alEnviar: (v: string) => void; alDetener: () => void;
  /** La procedencia del mundo entero, para el descargo permanente. Se compone de las fuentes
   *  cargadas: en cuanto UNA es real, la frase «los datos son sintéticos» deja de ser cierta. */
  origenMundo: Origen;
}) {
  const txt = t(idioma);
  const ref = useRef<HTMLTextAreaElement>(null);
  const [alto, setAlto] = useState<number | undefined>(undefined);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (!valor) { setAlto(undefined); return; }   // vacío: lo decide el CSS (una línea)
    el.style.height = "auto";
    setAlto(Math.min(el.scrollHeight, 168));
  }, [valor]);

  const enviar = () => {
    const limpio = valor.trim();
    if (!limpio || ocupado) return;
    alEnviar(limpio);
    alValor("");
  };

  return (
    <div className="composer">
      <form className="composer-caja" onSubmit={(e) => { e.preventDefault(); enviar(); }}>
        <textarea
          ref={ref}
          value={valor}
          rows={1}
          style={alto ? { height: alto } : undefined}
          onChange={(e) => alValor(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); enviar(); }
          }}
          placeholder={txt.preguntar}
          maxLength={2000}
          aria-label={txt.preguntar}
        />
        {ocupado ? (
          <button type="button" className="enviar detener" onClick={alDetener} aria-label={txt.detener}>■</button>
        ) : (
          <button type="submit" className="enviar" disabled={!valor.trim()} aria-label={txt.enviar}>↑</button>
        )}
      </form>
      <p className="descargo">{txt.verificar} {txt.verificarOrigen[origenMundo]}</p>
    </div>
  );
}
